
import { useState } from 'react';

export default function Hero() {
  return (
    <section className="bg-white pt-32 pb-16">
      <div className="container mx-auto px-6 max-w-6xl">
        <div className="text-center mb-12">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Open Source Data Preparation<br />20x Faster
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto mb-8 leading-relaxed">
            Bumblebee is the easiest and most powerful tool to clean, transform, and prepare data of any size for Analysis, Visualization, Reporting, and Machine Learning. All in a spreadsheet-like interface
          </p>
          <a 
            href="https://optimusdata.typeform.com/to/AdJj1n" 
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-[#FFD93D] hover:bg-[#FFB627] text-gray-900 font-semibold px-8 py-3 rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Schedule a Demo
          </a>
        </div>

        <div className="mt-16 relative flex justify-center">
          <div className="bg-gray-100 rounded-lg shadow-2xl overflow-hidden border-8 border-gray-300 w-4/5">
            <div className="bg-gray-200 px-4 py-2 flex items-center gap-2">
              <div className="flex gap-1.5">
                <div className="w-3 h-3 rounded-full bg-red-400"></div>
                <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
                <div className="w-3 h-3 rounded-full bg-green-400"></div>
              </div>
            </div>
            <div className="aspect-video bg-white">
              <img 
                src="/assets/images/hero-interface.gif"
                alt="Bumblebee Interface"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
